import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import ReviewsInCatalog from '@containers/ReviewsInCatalog';
import apolloWrapper from '@hoc/apolloWrapper';
import { getClientLocale, I18NProvider } from '@utils/i18n';

const ReviewsInCatalogWithApollo = apolloWrapper(ReviewsInCatalog);

// const
const reviewsInCatalogBlock = document
  .querySelector('#js-reviews-block');

if (reviewsInCatalogBlock) {
  const root = createRoot(reviewsInCatalogBlock);
  const { lang, routerBasename } = getClientLocale();

  root.render(
    (
      <BrowserRouter basename={routerBasename}>
        <I18NProvider lang={lang}>
          {
            () => <ReviewsInCatalogWithApollo />
          }
        </I18NProvider>
      </BrowserRouter>
    ),
  );
}
